import React, {useContext} from 'react';
import {Box} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import AppContext from '../../../@vf/utility/AppContext';
import {ThemeMode} from '../../constants/AppEnums';
import Hidden from '@material-ui/core/Hidden';
import AppContextPropsType from '../../../types/AppContextPropsType';
import {useHistory} from 'react-router-dom';

const AppLogo = () => {
  const {themeMode} = useContext<AppContextPropsType>(AppContext);
  const history = useHistory();
  const useStyles = makeStyles(() => ({
    logoRoot: {
      display: 'flex',
      flexDirection: 'row',
      cursor: 'pointer',
      alignItems: 'center',
    },
    logo: {
      height: 36,
      marginRight: 10,
    },
  }));
  const classes = useStyles();
  return (
    <Box className={classes.logoRoot} onClick={() => history.push('/')}>
      <Hidden smUp>
        <img
          className={classes.logo}
          src={
            themeMode === ThemeMode.DARK
              ? '/D1_PatientSync_Supervisor_Dark.png'
              : '/D1_PatientSync_Supervisor_Dark.png'
          }
          alt='client-logo'
        />
      </Hidden>
      <Hidden xsDown>
        <img
          className={classes.logo}
          src={
            themeMode === ThemeMode.DARK
              ? '/D1_PatientSync_Supervisor_Dark.png'
              : '/D1_PatientSync_Supervisor_Dark.png'
          }
          alt='client-logo'
        />
      </Hidden>
    </Box>
  );
};

export default AppLogo;
